import { DecryptAesClientSide } from "./core/encryption";
import { environment } from "src/environments/environment";
import { StorageValues } from "./core/consts";

export const GlobalComponent = {
    // Api Calling
    API_URL : 'https://api-node.themesbrand.website/',
    // API_URL : 'http://127.0.0.1:3000/',
    headerToken : {'Authorization': `Bearer ${DecryptAesClientSide(
                                                         environment.useSessionStorage
                                                         ?
                                                         sessionStorage.getItem(StorageValues.encToken)
                                                         :
                                                         localStorage.getItem(StorageValues.encToken)
                                                        )
                                             }`},

    // Auth Api
    AUTH_API:"https://api-node.themesbrand.website/auth/",
    // AUTH_API:"http://127.0.0.1:3000/auth/",

    
    // Products Api
    product:'apps/product',
    productDelete:'apps/product/',

    // Orders Api
    order:'apps/order',
    orderId:'apps/order/',

    // Customers Api
    customer:'apps/customer',
}